module.exports = __webpack_public_path__ + "static/media/genisis17.7643fb36.jpg";